import { createUseTranslation } from "core/session/translation";

export const useFooterTranslation = createUseTranslation({
  en: {
    defaultFooterText:
      "CYPEX is a product developed by [CYBERTEC](https://www.cybertec-postgresql.com/).",
  },
});
